import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BriefcaseIcon, SearchIcon, FilterIcon, MapPinIcon, CalendarIcon, ClockIcon, BookmarkIcon, ExternalLinkIcon, Share2Icon, ChevronDownIcon, PlusIcon, XIcon, CheckIcon, SlackIcon, LinkedinIcon, BuildingIcon, TagIcon, FileTextIcon, UserIcon, UsersIcon, LogInIcon, UserPlusIcon, MessageCircleIcon, AlertCircleIcon, ArrowRightIcon } from 'lucide-react';
const Jobs = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [savedJobs, setSavedJobs] = useState<string[]>([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [visibleJobs, setVisibleJobs] = useState(4);
  const [linkCopied, setLinkCopied] = useState(false);
  const [activeInterviewTab, setActiveInterviewTab] = useState('tips');
  const toggleSaveJob = (jobId: string) => {
    if (!isLoggedIn) {
      setShowLoginPrompt(true);
      return;
    }
    if (savedJobs.includes(jobId)) {
      setSavedJobs(savedJobs.filter(id => id !== jobId));
    } else {
      setSavedJobs([...savedJobs, jobId]);
    }
  };
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  };
  const filters = [{
    id: 'all',
    name: 'All Jobs'
  }, {
    id: 'fullTime',
    name: 'Full-Time'
  }, {
    id: 'partTime',
    name: 'Part-Time'
  }, {
    id: 'contract',
    name: 'Contract'
  }, {
    id: 'remote',
    name: 'Remote'
  }, {
    id: 'internship',
    name: 'Internship'
  }];
  const jobs = [{
    id: '1',
    title: 'Software Developer',
    company: 'Tech Innovations Kenya',
    location: 'Nairobi, Kenya',
    type: 'Full-time',
    salary: 'KES 100,000 - 150,000',
    posted: '2 days ago',
    description: 'We are looking for a skilled Software Developer to join our team. The ideal candidate should have experience with React, Node.js, and database technologies.',
    requirements: ["Bachelor's degree in Computer Science or related field", '3+ years of experience in software development', 'Proficiency in React, Node.js, and SQL', 'Strong problem-solving skills'],
    applicationUrl: 'https://example.com/job1',
    logo: ''
  }, {
    id: '2',
    title: 'Marketing Manager',
    company: 'Growth Strategies Ltd',
    location: 'Mombasa, Kenya',
    type: 'Full-time',
    salary: 'KES 120,000 - 180,000',
    posted: '3 days ago',
    description: 'We are seeking a Marketing Manager to develop and implement marketing strategies to promote our products and services. The ideal candidate will have experience in digital marketing and brand management.',
    requirements: ["Bachelor's degree in Marketing or related field", '5+ years of experience in marketing', 'Experience with digital marketing platforms', 'Strong analytical and communication skills'],
    applicationUrl: 'https://example.com/job2',
    logo: ''
  }, {
    id: '3',
    title: 'Administrative Assistant',
    company: 'Kenya Business Solutions',
    location: 'Nairobi, Kenya',
    type: 'Part-time',
    salary: 'KES 30,000 - 45,000',
    posted: '1 week ago',
    description: 'We are looking for an Administrative Assistant to support our office operations. Responsibilities include managing schedules, handling correspondence, and organizing meetings.',
    requirements: ['Diploma in Business Administration or related field', '2+ years of experience in administrative roles', 'Proficiency in Microsoft Office Suite', 'Excellent organizational skills'],
    applicationUrl: 'https://example.com/job3',
    logo: ''
  }, {
    id: '4',
    title: 'Financial Analyst',
    company: 'East Africa Banking Group',
    location: 'Nairobi, Kenya',
    type: 'Full-time',
    salary: 'KES 150,000 - 200,000',
    posted: '5 days ago',
    description: 'We are seeking a Financial Analyst to analyze financial data and prepare reports to guide business decisions. The ideal candidate will have experience in financial modeling and forecasting.',
    requirements: ["Bachelor's degree in Finance, Accounting, or related field", '4+ years of experience in financial analysis', 'Proficiency in Excel and financial modeling', 'CFA certification is a plus'],
    applicationUrl: 'https://example.com/job4',
    logo: ''
  }, {
    id: '5',
    title: 'Content Writer',
    company: 'Digital Media Kenya',
    location: 'Remote',
    type: 'Contract',
    salary: 'KES 50,000 - 80,000',
    posted: '3 days ago',
    description: 'We are looking for a Content Writer to create engaging content for our digital platforms. The ideal candidate will have experience in writing for various audiences and formats.',
    requirements: ["Bachelor's degree in Journalism, Communications, or related field", '2+ years of experience in content writing', 'Strong writing and editing skills', 'Knowledge of SEO best practices'],
    applicationUrl: 'https://example.com/job5',
    logo: ''
  }, {
    id: '6',
    title: 'UI/UX Designer',
    company: 'Creative Solutions Kenya',
    location: 'Nairobi, Kenya',
    type: 'Full-time',
    salary: 'KES 90,000 - 130,000',
    posted: '1 week ago',
    description: 'We are seeking a UI/UX Designer to create visually appealing and user-friendly interfaces for our digital products. The ideal candidate will have experience in user research, wireframing, and prototyping.',
    requirements: ["Bachelor's degree in Design, HCI, or related field", '3+ years of experience in UI/UX design', 'Proficiency in design tools such as Figma and Adobe XD', 'Strong portfolio demonstrating design skills'],
    applicationUrl: 'https://example.com/job6',
    logo: ''
  }, {
    id: '7',
    title: 'Sales Representative',
    company: 'Kenya Commercial Solutions',
    location: 'Kisumu, Kenya',
    type: 'Full-time',
    salary: 'KES 70,000 - 100,000 + Commission',
    posted: '4 days ago',
    description: 'We are looking for a Sales Representative to promote our products and services to potential clients. The ideal candidate will have experience in B2B sales and relationship management.',
    requirements: ["Bachelor's degree in Business, Marketing, or related field", '3+ years of experience in sales', 'Strong communication and negotiation skills', 'Proven track record of meeting sales targets'],
    applicationUrl: 'https://example.com/job7',
    logo: ''
  }, {
    id: '8',
    title: 'HR Manager',
    company: 'Kenya Human Resources Ltd',
    location: 'Nairobi, Kenya',
    type: 'Full-time',
    salary: 'KES 130,000 - 180,000',
    posted: '2 weeks ago',
    description: 'We are seeking an HR Manager to oversee our human resources operations. Responsibilities include recruitment, employee relations, and policy development.',
    requirements: ["Bachelor's degree in Human Resources, Business, or related field", '5+ years of experience in HR management', 'Knowledge of Kenyan labor laws and regulations', 'Strong leadership and communication skills'],
    applicationUrl: 'https://example.com/job8',
    logo: ''
  }];
  // Filter jobs based on selected filter
  const filteredJobs = activeFilter === 'all' ? jobs : jobs.filter(job => {
    if (activeFilter === 'fullTime' && job.type === 'Full-time') return true;
    if (activeFilter === 'partTime' && job.type === 'Part-time') return true;
    if (activeFilter === 'contract' && job.type === 'Contract') return true;
    if (activeFilter === 'remote' && job.location === 'Remote') return true;
    if (activeFilter === 'internship' && job.type === 'Internship') return true;
    return false;
  });
  const displayedJobs = filteredJobs.slice(0, visibleJobs);
  const hasMoreJobs = filteredJobs.length > visibleJobs;
  const loadMoreJobs = () => {
    if (!isLoggedIn) {
      setShowLoginPrompt(true);
      return;
    }
    setVisibleJobs(prevCount => prevCount + 4);
  };
  // Interview tips content
  const interviewBuzzwords = [{
    avoid: "I'm Hardworking",
    better: 'I consistently go above and beyond in my tasks.'
  }, {
    avoid: "I'm Detail-oriented",
    better: 'I have a keen eye for catching errors.'
  }, {
    avoid: "I'm a Quick Learner",
    better: 'I adapt swiftly to new tools and technologies.'
  }, {
    avoid: "I'm Flexible",
    better: 'I adapt easily to changing circumstances & challenges.'
  }, {
    avoid: "I'm a Problem-solver",
    better: 'I enjoy tackling complex challenges & finding solutions.'
  }, {
    avoid: "I'm Passionate About My Work",
    better: 'I am deeply committed to achieving excellence in my field.'
  }, {
    avoid: "I'm a Good Communicator",
    better: 'I excel at articulating ideas clearly and concisely.'
  }, {
    avoid: "I'm Result-oriented",
    better: 'I consistently achieve and exceed performance targets.'
  }, {
    avoid: "I'm Motivated",
    better: 'I am self-driven & consistently strive for excellence.'
  }];
  const interviewTips = [{
    title: 'Research the company thoroughly',
    description: "Understand the company's mission, values, products/services, competitors, and recent news before your interview."
  }, {
    title: 'Prepare for common questions',
    description: "Practice answers to questions like 'Tell me about yourself,' 'Why do you want this job?', and 'What are your strengths and weaknesses?'"
  }, {
    title: 'Use the STAR method for behavioral questions',
    description: 'Structure your answers with Situation, Task, Action, and Result to showcase your experience effectively.'
  }, {
    title: 'Prepare thoughtful questions',
    description: 'Have 3-5 insightful questions ready to ask the interviewer about the role, team, or company culture.'
  }, {
    title: 'Practice your body language',
    description: 'Maintain good posture, make appropriate eye contact, and practice a firm handshake.'
  }, {
    title: 'Dress appropriately',
    description: 'Research the company culture and dress one level above what employees typically wear.'
  }];
  return <div className="pb-16" data-id="element-2375">
      <div className="border-b border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-2376">
        <div className="max-w-4xl mx-auto p-4" data-id="element-2377">
          <h1 className="text-2xl font-bold mb-2 flex items-center dark:text-gray-200" data-id="element-2378">
            <BriefcaseIcon className="w-6 h-6 mr-2" data-id="element-2379" />
            Jobs
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-2380">
            Find your next career opportunity in Kenya
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-2381">
        {/* Login Prompt Modal */}
        {showLoginPrompt && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2382">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full" data-id="element-2383">
              <div className="flex justify-between items-center mb-4" data-id="element-2384">
                <h3 className="text-lg font-bold dark:text-gray-200" data-id="element-2385">
                  Sign in to continue
                </h3>
                <button onClick={() => setShowLoginPrompt(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-2386">
                  <XIcon className="w-5 h-5 dark:text-gray-300" data-id="element-2387" />
                </button>
              </div>
              <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-2388">
                Sign in or create an account to save jobs, view more listings,
                and apply to positions.
              </p>
              <div className="flex space-x-3" data-id="element-2389">
                <Link to="/register" className="flex-1 flex justify-center items-center px-4 py-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md" onClick={() => setShowLoginPrompt(false)} data-id="element-2390">
                  <LogInIcon className="w-4 h-4 mr-2" data-id="element-2391" />
                  Sign In
                </Link>
                <Link to="/register" className="flex-1 flex justify-center items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:text-gray-200" onClick={() => setShowLoginPrompt(false)} data-id="element-2392">
                  <UserPlusIcon className="w-4 h-4 mr-2" data-id="element-2393" />
                  Register
                </Link>
              </div>
            </div>
          </div>}
        {/* Search and Filter */}
        <div className="mb-6" data-id="element-2394">
          <div className="relative mb-4" data-id="element-2395">
            <input type="text" placeholder="Search for jobs, companies, or keywords..." className="w-full p-3 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-800 dark:text-gray-200" data-id="element-2396" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2397" />
            <button className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-2398">
              <FilterIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2399" />
            </button>
          </div>
          <div className="flex overflow-x-auto space-x-2 pb-2" data-id="element-2400">
            {filters.map(filter => <button key={filter.id} onClick={() => setActiveFilter(filter.id)} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeFilter === filter.id ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-2401">
                {filter.name}
              </button>)}
          </div>
        </div>
        {/* Interview Tips Section */}
        <div className="mb-8 border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-2402">
          <div className="bg-gray-100 dark:bg-gray-800 p-4 border-b border-gray-300 dark:border-gray-600" data-id="element-2403">
            <h2 className="text-lg font-bold flex items-center dark:text-gray-200" data-id="element-2404">
              <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-2405" />
              Interview Preparation Guide
            </h2>
            <div className="flex mt-3 border-b border-gray-300 dark:border-gray-600" data-id="element-2406">
              <button onClick={() => setActiveInterviewTab('tips')} className={`px-4 py-2 text-sm ${activeInterviewTab === 'tips' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-2407">
                General Tips
              </button>
              <button onClick={() => setActiveInterviewTab('buzzwords')} className={`px-4 py-2 text-sm ${activeInterviewTab === 'buzzwords' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-2408">
                Avoid Buzzwords
              </button>
              <button onClick={() => setActiveInterviewTab('questions')} className={`px-4 py-2 text-sm ${activeInterviewTab === 'questions' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-2409">
                Common Questions
              </button>
            </div>
          </div>
          <div className="p-4" data-id="element-2410">
            {activeInterviewTab === 'tips' && <div data-id="element-2411">
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-2412">
                  Preparing for an interview is crucial for making a strong
                  impression. Here are some key tips to help you succeed:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-2413">
                  {interviewTips.map((tip, index) => <div key={index} className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-2414">
                      <h3 className="font-medium mb-2 dark:text-gray-200" data-id="element-2415">
                        {tip.title}
                      </h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2416">
                        {tip.description}
                      </p>
                    </div>)}
                </div>
                <div className="flex flex-wrap gap-2 mt-4" data-id="element-2417">
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2418">
                    #interview
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2419">
                    #jobsearch
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2420">
                    #careeradvice
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2421">
                    #interviewprep
                  </span>
                </div>
              </div>}
            {activeInterviewTab === 'buzzwords' && <div data-id="element-2422">
                <div className="flex items-start mb-4" data-id="element-2423">
                  <AlertCircleIcon className="w-5 h-5 text-gray-800 dark:text-gray-200 mt-1 mr-2 flex-shrink-0" data-id="element-2424" />
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2425">
                    Avoid using generic buzzwords in your interview. These
                    overused phrases have lost their meaning and don't
                    effectively showcase your skills. Instead, use specific
                    examples and alternative phrases that demonstrate your
                    abilities.
                  </p>
                </div>
                <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-4" data-id="element-2426">
                  <div className="bg-gray-100 dark:bg-gray-800 p-3 border-b border-gray-300 dark:border-gray-600 text-center font-bold" data-id="element-2427">
                    <h3 className="dark:text-gray-200" data-id="element-2428">
                      DON'T SAY THIS IN AN INTERVIEW!
                    </h3>
                  </div>
                  <div className="p-3" data-id="element-2429">
                    {interviewBuzzwords.map((item, index) => <div key={index} className="mb-3 last:mb-0" data-id="element-2430">
                        <div className="flex items-center mb-2" data-id="element-2431">
                          <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center mr-2" data-id="element-2432">
                            <XIcon className="w-4 h-4 text-gray-800 dark:text-gray-200" data-id="element-2433" />
                          </div>
                          <div className="border border-gray-300 dark:border-gray-600 rounded px-3 py-1 flex-1" data-id="element-2434">
                            <p className="text-sm font-medium dark:text-gray-200" data-id="element-2435">
                              {item.avoid}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center pl-8" data-id="element-2436">
                          <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center mr-2" data-id="element-2437">
                            <CheckIcon className="w-4 h-4 text-gray-800 dark:text-gray-200" data-id="element-2438" />
                          </div>
                          <div className="border border-gray-300 dark:border-gray-600 rounded px-3 py-1 flex-1" data-id="element-2439">
                            <p className="text-sm dark:text-gray-200" data-id="element-2440">
                              {item.better}
                            </p>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-4" data-id="element-2441">
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2442">
                    #interviewtips
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2443">
                    #communicationskills
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2444">
                    #jobinterviews
                  </span>
                </div>
              </div>}
            {activeInterviewTab === 'questions' && <div data-id="element-2445">
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-2446">
                  Here are some common interview questions and tips on how to
                  approach them effectively:
                </p>
                <div className="space-y-4 mb-4" data-id="element-2447">
                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-2448">
                    <h3 className="font-medium mb-2 dark:text-gray-200" data-id="element-2449">
                      Tell me about yourself
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-2450">
                      Keep your answer concise (1-2 minutes) and focused on your
                      professional background. Structure it as: brief
                      introduction, relevant experience, why you're interested
                      in this role.
                    </p>
                    <div className="text-sm text-gray-600 dark:text-gray-400 border-l-2 border-gray-300 dark:border-gray-600 pl-3 italic" data-id="element-2451">
                      "I'm a software developer with 5 years of experience
                      specializing in web applications. At my current role, I
                      led the development of a customer portal that improved
                      satisfaction scores by 30%. I'm particularly interested in
                      this position because it aligns with my expertise in React
                      and my passion for creating user-focused solutions."
                    </div>
                  </div>
                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-2452">
                    <h3 className="font-medium mb-2 dark:text-gray-200" data-id="element-2453">
                      What is your greatest weakness?
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-2454">
                      Be honest but strategic. Mention a genuine weakness, but
                      focus on the steps you're taking to improve it.
                    </p>
                    <div className="text-sm text-gray-600 dark:text-gray-400 border-l-2 border-gray-300 dark:border-gray-600 pl-3 italic" data-id="element-2455">
                      "I've sometimes struggled with delegation, as I tend to
                      take on too much responsibility. However, I've been
                      working on this by implementing project management tools
                      and setting up regular check-ins with team members, which
                      has helped me become more comfortable with distributing
                      tasks effectively."
                    </div>
                  </div>
                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-2456">
                    <h3 className="font-medium mb-2 dark:text-gray-200" data-id="element-2457">
                      Why should we hire you?
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-2458">
                      Connect your skills and experience directly to the job
                      requirements. Highlight your unique value proposition.
                    </p>
                    <div className="text-sm text-gray-600 dark:text-gray-400 border-l-2 border-gray-300 dark:border-gray-600 pl-3 italic" data-id="element-2459">
                      "Based on the job description, you need someone who can
                      optimize marketing campaigns and increase ROI. In my
                      previous role, I increased conversion rates by 25% through
                      data-driven campaign optimization. I also bring experience
                      with the specific analytics tools you use, allowing me to
                      make an immediate impact while requiring minimal
                      onboarding."
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-4" data-id="element-2460">
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2461">
                    #interviewquestions
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2462">
                    #jobprep
                  </span>
                  <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full" data-id="element-2463">
                    #careeradvice
                  </span>
                </div>
              </div>}
            <div className="mt-6 text-center" data-id="element-2464">
              <Link to="/blog/interview-tips" className="inline-flex items-center text-sm text-gray-800 dark:text-gray-200 hover:underline" data-id="element-2465">
                Read our full interview preparation guide{' '}
                <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2466" />
              </Link>
            </div>
          </div>
        </div>
        {/* Job Listings */}
        <div className="mb-6" data-id="element-2467">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2468">
            Featured Jobs
          </h2>
          {displayedJobs.length > 0 ? <div className="space-y-4" data-id="element-2469">
              {displayedJobs.map(job => <div key={job.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-2470">
                  <div className="flex items-start" data-id="element-2471">
                    <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-md flex items-center justify-center mr-3" data-id="element-2472">
                      {job.logo ? <img src={job.logo} alt={job.company} className="w-full h-full rounded-md object-cover" data-id="element-2473" /> : <BuildingIcon className="w-6 h-6 text-gray-500 dark:text-gray-400" data-id="element-2474" />}
                    </div>
                    <div className="flex-1" data-id="element-2475">
                      <h3 className="font-medium mb-1 dark:text-gray-200" data-id="element-2476">
                        {job.title}
                      </h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-1" data-id="element-2477">
                        {job.company}
                      </p>
                      <div className="flex flex-wrap items-center text-xs text-gray-500 dark:text-gray-400 mb-2" data-id="element-2478">
                        <div className="flex items-center mr-3" data-id="element-2479">
                          <MapPinIcon className="w-3 h-3 mr-1" data-id="element-2480" />
                          <span data-id="element-2481">{job.location}</span>
                        </div>
                        <div className="flex items-center mr-3" data-id="element-2482">
                          <BriefcaseIcon className="w-3 h-3 mr-1" data-id="element-2483" />
                          <span data-id="element-2484">{job.type}</span>
                        </div>
                        <div className="flex items-center" data-id="element-2485">
                          <CalendarIcon className="w-3 h-3 mr-1" data-id="element-2486" />
                          <span data-id="element-2487">Posted {job.posted}</span>
                        </div>
                      </div>
                      <div className="flex items-center text-sm font-medium mb-3 dark:text-gray-300" data-id="element-2488">
                        {job.salary}
                      </div>
                      <div className="flex justify-between items-center" data-id="element-2489">
                        <a href={job.applicationUrl} target="_blank" rel="noopener noreferrer" className="text-xs bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-3 py-1 rounded-md flex items-center" data-id="element-2490">
                          Apply Now
                          <ExternalLinkIcon className="w-3 h-3 ml-1" data-id="element-2491" />
                        </a>
                        <div className="flex space-x-2" data-id="element-2492">
                          <button onClick={() => toggleSaveJob(job.id)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" aria-label={savedJobs.includes(job.id) ? 'Unsave job' : 'Save job'} data-id="element-2493">
                            <BookmarkIcon className={`w-5 h-5 ${savedJobs.includes(job.id) ? 'fill-gray-800 dark:fill-gray-200 text-gray-800 dark:text-gray-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-2494" />
                          </button>
                          <button onClick={() => copyToClipboard(`Check out this job: ${job.title} at ${job.company} - ${job.location}`)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" aria-label="Share job" data-id="element-2495">
                            <Share2Icon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2496" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div> : <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-8 text-center" data-id="element-2497">
              <BriefcaseIcon className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500 mb-2" data-id="element-2498" />
              <p className="text-gray-600 dark:text-gray-400" data-id="element-2499">
                No jobs found matching your criteria
              </p>
              <button onClick={() => setActiveFilter('all')} className="mt-3 text-sm text-gray-800 dark:text-gray-200 underline" data-id="element-2500">
                View all jobs
              </button>
            </div>}
          {hasMoreJobs && <div className="mt-4 text-center" data-id="element-2501">
              <button onClick={loadMoreJobs} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm dark:text-gray-200" data-id="element-2502">
                Load More Jobs
              </button>
            </div>}
        </div>
        {/* Top Companies */}
        <div className="mb-6" data-id="element-2503">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2504">
            Top Companies Hiring
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-2505">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2506">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-2507">
                <BuildingIcon className="w-8 h-8 text-gray-500 dark:text-gray-400" data-id="element-2508" />
              </div>
              <h3 className="font-medium text-sm mb-1 dark:text-gray-200" data-id="element-2509">
                Safaricom PLC
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2510">
                12 open positions
              </p>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2511">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-2512">
                <BuildingIcon className="w-8 h-8 text-gray-500 dark:text-gray-400" data-id="element-2513" />
              </div>
              <h3 className="font-medium text-sm mb-1 dark:text-gray-200" data-id="element-2514">
                Equity Bank
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2515">
                8 open positions
              </p>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2516">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-2517">
                <BuildingIcon className="w-8 h-8 text-gray-500 dark:text-gray-400" data-id="element-2518" />
              </div>
              <h3 className="font-medium text-sm mb-1 dark:text-gray-200" data-id="element-2519">
                KCB Group
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2520">
                6 open positions
              </p>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2521">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-2522">
                <BuildingIcon className="w-8 h-8 text-gray-500 dark:text-gray-400" data-id="element-2523" />
              </div>
              <h3 className="font-medium text-sm mb-1 dark:text-gray-200" data-id="element-2524">
                Twiga Foods
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2525">
                5 open positions
              </p>
            </div>
          </div>
        </div>
        {/* Career Resources */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-2526">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2527">
            Career Resources
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2528">
            <div className="flex items-start" data-id="element-2529">
              <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-md flex items-center justify-center mr-3" data-id="element-2530">
                <FileTextIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2531" />
              </div>
              <div data-id="element-2532">
                <h3 className="text-sm font-medium mb-1 dark:text-gray-200" data-id="element-2533">
                  Resume Writing Tips
                </h3>
                <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-2534">
                  Learn how to create a standout resume that gets noticed by
                  employers.
                </p>
                <a href="#" className="text-xs text-gray-800 dark:text-gray-200 hover:underline mt-1 inline-block" data-id="element-2535">
                  Read More
                </a>
              </div>
            </div>
            <div className="flex items-start" data-id="element-2536">
              <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-md flex items-center justify-center mr-3" data-id="element-2537">
                <UsersIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2538" />
              </div>
              <div data-id="element-2539">
                <h3 className="text-sm font-medium mb-1 dark:text-gray-200" data-id="element-2540">
                  Interview Preparation
                </h3>
                <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-2541">
                  Tips and strategies to help you ace your next job interview.
                </p>
                <a href="#" className="text-xs text-gray-800 dark:text-gray-200 hover:underline mt-1 inline-block" data-id="element-2542">
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Copied to clipboard notification */}
        {linkCopied && <div className="fixed bottom-4 right-4 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md flex items-center z-50" data-id="element-2543">
            <CheckIcon className="w-4 h-4 mr-2" data-id="element-2544" />
            <span data-id="element-2545">Copied to clipboard</span>
          </div>}
      </div>
    </div>;
};
export default Jobs;